module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-9.128c4e12.svg";